module.exports = __webpack_public_path__ + "static/media/img-producto-barandal.8d8fbb21.png";